import { PayRunEmployeeStatus, PayRunStatus } from '$constants'
import dayjs, { Dayjs } from 'dayjs'
import { Nullable, StaffMember } from '$models'
import sortBy from 'lodash/sortBy'

export interface PayRun {
  id: string
  periodStartDate: Dayjs
  periodEndDate: Dayjs
  paymentDate: Dayjs
  employeesWorked: number
  employeesPaid: number
  loadedPay: number
  payrollPay: number
  payslipMessage?: Nullable<string>
  employees?: Employee[]
  status?: PayRunStatus
  payrollSystemCompanyId?: string
}

//This employee is only for Pay runs for now
export type Employee = Partial<StaffMember> & {
  loadedWages: number
  payrollSystemWages: number
  status: PayRunEmployeeStatus
}

// Function to apply transformations to PayClassification object
export const transformPayRunOnGet = (payClassification: PayRun): PayRun => {
  return {
    ...payClassification,
    periodStartDate: dayjs(payClassification.periodStartDate),
    periodEndDate: dayjs(payClassification.periodEndDate),
    paymentDate: dayjs(payClassification.paymentDate),
    employees: payClassification.employees
      ? sortBy<Employee>(payClassification.employees, 'firstName', 'lastName')
      : [],
  }
}
